module.exports = __webpack_public_path__ + "static/img/princess.d3ce75e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/collage/papercuts/princess.jpg
// module id = w0Gu
// module chunks = 1